import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactGA from 'react-ga'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo)
    ReactGA.exception({
      description: error.message,
      fatal: true,
    })
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Alert className='m-4' variant='danger'>
          <Alert.Heading>An error occurred</Alert.Heading>
          <p>
            Something went wrong and our team has been automatically notified.
          </p>
          <p>
            You may want to or try a different web browser, or you can click
            this button to reset your cache (EDHREC only).
          </p>
          <p>
            <Button
              onClick={() => {
                localStorage.removeItem('edhrec_layout')
                localStorage.removeItem('edhrec_scrollspy_hidden')
                localStorage.removeItem('edhrec_video')
                localStorage.removeItem('persist:root')
              }}
            >
              Reset cache
            </Button>
          </p>
          <p class='mb-0'>
            You can also <Link to='/bug-report'>submit a bug report</Link> or
            email us at{' '}
            <Link to='mailto:bugreport@edhrec.com'>bugreport@edhrec.com</Link>.
          </p>
        </Alert>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
